<template>
  <div class="playout-load-dashboard">
    <div class="chart-container" style="min-height: 380px">
      <line-chart
        class="chart"
        style="min-height: 380px;"
        :showLegend="showLegend"
        :showGridLines="showLegend"
        :data="trendData"
        :labels="labels"
        :xAxeslabelString="'Quarter Hour Uniques'"
      ></line-chart>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart';

export default {
  name: 'StreamingLoad',

  props: {
    data: {
      type: Array,
      default: [],
    },
    showLegend: {
      type: Boolean,
      default: true,
    },
    isTrimesterComplete: {
      type: Boolean,
      default: false,
    },
    showGridLines: {
      type: Boolean,
      default: true,
    },
    periodLabel: {
      type: String,
      default: 'Full week average',
    },
    avg3monthsLabel: {
      type: String,
      default: '3 month average',
    },
    incomAvg3monthsLabel: {
      type: String,
      default: '3 months data not yet available',
    },
  },

  computed: {
    labels() {
      if (this.isTrimesterComplete) {
        return [this.periodLabel, this.avg3monthsLabel];
      }
      return [this.periodLabel, this.incomAvg3monthsLabel];
    },

    trendData() {
      return this.data.map(x => x.map(y =>
      [`${y.hour}:${y.interval}`, this.getlisteners(y.value)]));
    },
  },

  methods: {
    getlisteners(listeners) {
      return listeners !== null ? listeners.toFixed() : 0;
    },
  },

  components: { LineChart },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';

.playout-load-dashboard {
  width: 100%;
  height: 100%;
}

.warning{
  padding: 2px;
  text-align: center;
  background-color: #A8A8A8;
}

.metric-text {
  font-size: 0.9em;

  .metric-text-title {
    color: $colony-purple;
    font-weight: bold;
  }
}

.chart-container {
  position: relative;
  height: 180px;
  margin-top: 42px;
}

.chart {
  position: absolute;
  width: 100%;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// StreamingLoad.vue?6a52d73c